module.exports = __webpack_public_path__ + "img/restaurant.2ef786d1.png";